var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-pane",attrs:{"role":"tabcard","id":"selections"}},[_c('selection-list',{attrs:{"role":_vm.role,"user":_vm.user,"project":_vm.project}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }